import { usePaymentsMethodsApi } from '@api/payments/payments-methods.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( () => {
  void usePaymentsMethodsApi()
})
